module.exports = "/_next/static/images/T2_hires@2x-1b8182aab0af7a1951774070adb52f71.png";